<div class="dialog-header">
  <div class="header-title"><span style="font-size: 120%;">{{dialogHeader}}</span></div>
  <div class="buttons-block" *ngIf="showSendButton">

    <button class="open-source-button" mat-button (click)="openPdfInNewTab()">
      <span>Browser View</span>
    </button>
  </div>

  <button mat-button class="close-button-container" [mat-dialog-close]="true" disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="pdf-block">
    <lib-progress-spinner *ngIf="showLoadingSpinner"></lib-progress-spinner>

    <ngx-extended-pdf-viewer *ngIf="!showLoadingSpinner"
                             [src]="blobUrl"
                             [enablePinchOnMobile]="true"
                             [zoom]="'page-width'"
                             [showPresentationModeButton]="false"
                             [handTool]="false"
                             [showBookmarkButton]="false"
                             [minZoom]="0.8"
                             [showOpenFileButton]="false">
    </ngx-extended-pdf-viewer>

  </div>
</div>
